import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import {
  CreatePinList,
  CreatePinListResponse,
  GetPinReq,
  Pin,
  PinDetail,
  UpdatePinGroup,
} from "interfaces/models/pin";
import { axiosECS } from "services/baseAxios";

const pathV2 = PATH_API.INSPECTION_PIN;

const getPinList = async (params: GetPinReq): Promise<ApiResponse<Pin[]>> => {
  const { limit, ...rest } = params;

  return axiosECS.get(pathV2, {
    params: { limit: limit || 500, ...rest },
  });
};

const getPin = async (
  id: string,
  shouldCache?: boolean
): Promise<ApiResponse<PinDetail>> => {
  return axiosECS.get(`${pathV2}/${id}`, { params: { shouldCache } });
};

const createPinList = async (
  args: CreatePinList
): Promise<ApiResponse<CreatePinListResponse>> => {
  return axiosECS.post(pathV2, args);
};

const updatePin = async (pin: Partial<Pin>): Promise<ApiResponse<Pin>> => {
  return axiosECS.patch(pathV2, pin);
};

const deletePinList = async (ids: string[]): Promise<ApiResponse<string[]>> => {
  return axiosECS.delete(pathV2, {
    data: { ids },
  });
};

// add or remove pin from group
const updatePinGroup = async (
  body: UpdatePinGroup
): Promise<ApiResponse<UpdatePinGroup>> => {
  return axiosECS.patch(`${pathV2}/group`, body);
};

export const PinApi = {
  createPinList,
  updatePin,
  deletePinList,
  updatePinGroup,
  getPin,
  getPinList,
};
